import React from 'react';

import { Card, CardHeader } from '@/components/ui/card';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { formatNumber } from '@/lib/formatNumber';

export const description = 'A card to display plan allocation and usage status';

export interface PlanUsageCardProps {
  title: string;
  current: number;
  limit?: number;
  subtitle?: string;
  className?: string;
}

export function PlanUsageCard({ title, current, limit, subtitle, className }: PlanUsageCardProps) {
  const formattedCurrent = formatNumber(current);

  const isNumericLimit = typeof limit === 'number';

  const limitText = isNumericLimit ? formatNumber(limit) : 'Custom';

  const showTooltip = current >= 1000 || (isNumericLimit && limit >= 1000);

  return (
    <Card className={cn('p-4 shadow-none rounded-2xl border-none', className)}>
      <CardHeader className="p-0 space-y-1">
        <div className="flex items-baseline gap-0.5">
          <span className="text-dark text-3xl font-bold leading-tight">
            {showTooltip ? (
              <Tooltip>
                <TooltipTrigger asChild>
                  <span>{formattedCurrent}</span>
                </TooltipTrigger>
                <TooltipContent>{current}</TooltipContent>
              </Tooltip>
            ) : (
              formattedCurrent
            )}
          </span>

          <span className="text-muted-foreground text-xl leading-tight">/{limitText}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-muted-foreground text-sm">{title}</span>

          {subtitle && <span className="text-muted-foreground text-sm">{subtitle}</span>}
        </div>
      </CardHeader>
    </Card>
  );
}
